import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { formatDuration } from '../helpers/utils';
import { useGlobalContext } from '../GlobalContext';
import MyMap from '../components/MyMap';
import './ItineraryMapview.scss';

const getAdjacentEvents = (events, activeElement) => {
  let currentEvent = null;
  let nextEvent = null;
  let prevEvent = null;

  const currentIndex = events.findIndex(
    (event) => event.id === activeElement?.id,
  );

  if (currentIndex !== -1) {
    currentEvent = events[currentIndex];

    if (currentIndex + 1 < events.length) {
      nextEvent = events[currentIndex + 1];
    }

    if (currentIndex > 0) {
      prevEvent = events[currentIndex - 1];
    }
  }

  return { currentEvent, nextEvent, prevEvent };
};

const ItineraryMapview = () => {
  const { selectedDay, setSelectedDay, days, activeElement, setActiveElement } =
    useGlobalContext();
  const navigate = useNavigate();
  const day = days[selectedDay];

  const handleElementChange = useCallback((element) => {
    setActiveElement({ type: element.type, id: element.id });
  }, []);

  const { events } = day;
  const { prevEvent, currentEvent, nextEvent } = getAdjacentEvents(
    events,
    activeElement,
  );

  useEffect(() => {
    if (!day) {
      navigate('/chat');
    }
  }, [day, navigate]);

  if (!day) {
    return null;
  }

  return (
    <div className="itinerary-mapview-wrapper">
      <div>
        <div className="top">
          <header className="header">Itinerary</header>
          <img
            src="/images/listview.png"
            alt="List View"
            role="presentation"
            onClick={() => navigate('/itinerary/listview')}
          />
        </div>
        <div className="tabs">
          <ul>
            <li>Overview</li>
            {Object.keys(days).map((d) => (
              <li
                key={d}
                className={d === selectedDay ? 'active' : ''}
                onClick={() => setSelectedDay(d)}
                role="presentation"
              >
                Day {d}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div>
        <div className="itinerary-content">
          <div>
            <h2>{moment(day.events[0].date).format('MM/DD (ddd)')}</h2>
          </div>
          <div className="map-content">
            <MyMap
              day={day}
              activeElement={activeElement}
              onElementChange={handleElementChange}
            />
          </div>
          <div className="footer-content">
            {currentEvent && (
              <div
                className="col"
                role="presentation"
                onClick={() =>
                  prevEvent &&
                  handleElementChange({ type: 'event', id: prevEvent?.id })
                }
              >
                <div className="event">
                  <div className="number">{currentEvent.number}</div>
                  <p>{currentEvent.location}</p>
                </div>
              </div>
            )}
            <div className="col route-info">
              {nextEvent && (
                <div>
                  <div className="driving-mode">
                    <img
                      src={`/images/eta-${nextEvent.drivingMode}.png`}
                      alt={nextEvent.drivingMode}
                    />
                  </div>
                  <p>{formatDuration(nextEvent.route?.duration)}</p>
                </div>
              )}
            </div>
            {nextEvent && (
              <div
                className="col"
                role="presentation"
                onClick={() =>
                  handleElementChange({ type: 'event', id: nextEvent?.id })
                }
              >
                <div className="event event-next">
                  <div className="number">{nextEvent.number}</div>
                  <p>{nextEvent.location}</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItineraryMapview;
